// extracted by mini-css-extract-plugin
export var imagePanels = "styles-module--imagePanels--9f56d";
export var panels = "styles-module--panels--b5ac0";
export var title = "styles-module--title--c907a";